document.addEventListener('DOMContentLoaded', () => {
  if (window.lucide) lucide.createIcons();

  refreshCartUI();
  initModalAutoOpen();
  initPDPAddToCart();
  initPDPVariantSelector();
  loadProductRecommendations();
});


/* ---------------- Nav ---------------- */

function toggleNavMenu() {
  const overlay = document.getElementById('navOverlay');
  if (!overlay) return;

  if (overlay.classList.contains('opacity-0')) {
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    overlay.classList.add('opacity-100', 'pointer-events-auto');
  } else {
    overlay.classList.add('opacity-0', 'pointer-events-none');
    overlay.classList.remove('opacity-100', 'pointer-events-auto');
  }
}


/* ---------------- Toast ---------------- */

function showToast(msg) {
  const toast = document.getElementById('toastNotification');
  const msgEl = document.getElementById('toastMessage');

  if (!toast || !msgEl) return;

  msgEl.innerText = msg;

  toast.classList.remove('translate-y-24', 'opacity-0');
  toast.classList.add('translate-y-0', 'opacity-100');

  setTimeout(() => {
    toast.classList.remove('translate-y-0', 'opacity-100');
    toast.classList.add('translate-y-24', 'opacity-0');
  }, 3500);
}


/* ---------------- Cart drawer (Shopify Ajax Cart API) ---------------- */

function openCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const backdrop = document.getElementById('cartBackdrop');
  const content = document.getElementById('cartContent');

  if (!drawer || !backdrop || !content) return;

  drawer.classList.remove('pointer-events-none');

  backdrop.classList.remove('opacity-0');
  backdrop.classList.add('opacity-100');

  content.classList.remove('translate-x-full');
  content.classList.add('translate-x-0');
}


function closeCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const backdrop = document.getElementById('cartBackdrop');
  const content = document.getElementById('cartContent');

  if (!drawer || !backdrop || !content) return;

  content.classList.remove('translate-x-0');
  content.classList.add('translate-x-full');

  backdrop.classList.remove('opacity-100');
  backdrop.classList.add('opacity-0');

  setTimeout(() => {
    drawer.classList.add('pointer-events-none');
  }, 300);
}


/* ---------------- Money ---------------- */

function formatMoney(cents) {
  const format = window.NUHAS?.moneyFormat || '${{amount}}';

  const amount = (Number(cents || 0) / 100).toFixed(2);

  const amountNoDecimals = Math.round(
    Number(cents || 0) / 100
  ).toLocaleString('en-US');

  const amountWithCommas = Number(cents || 0) / 100;

  const formattedWithCommas = amountWithCommas.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return format
    .replace(
      /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
      amountNoDecimals
    )
    .replace(
      /\{\{\s*amount_with_comma_separator\s*\}\}/g,
      formattedWithCommas
    )
    .replace(
      /\{\{\s*amount_no_decimals\s*\}\}/g,
      amountNoDecimals
    )
    .replace(
      /\{\{\s*amount\s*\}\}/g,
      amount
    );
}


/* ---------------- Escape HTML ---------------- */

function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>'"]/g, char => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
  }[char]));
}


/* ---------------- Load Cart ---------------- */

async function refreshCartUI() {
  try {
    const cartUrl = (window.NUHAS?.routes?.cart || '/cart') + '.js';

    const res = await fetch(cartUrl, {
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!res.ok) {
      throw new Error(`Cart request failed: ${res.status}`);
    }

    const cart = await res.json();

    renderCartDrawer(cart);

  } catch (e) {
    console.error('Could not load cart:', e);
  }
}


/* ---------------- Render Cart Drawer ---------------- */

function renderCartDrawer(cart) {
  const badge = document.getElementById('cartBadge');
  const container = document.getElementById('cartItemsContainer');
  const subtotalEl = document.getElementById('cartSubtotal');

  if (!container) return;

  /*
   * Update cart badge
   */
  if (badge) {
    badge.innerText = cart.item_count;
  }


  /*
   * Empty cart
   */
  if (cart.item_count === 0) {
    container.innerHTML = `
      <div class="text-center py-12 text-xs text-stone-400 font-light">
        Your shopping bag is currently empty.
      </div>
    `;

    if (subtotalEl) {
      subtotalEl.innerText = formatMoney(0);
    }

    renderFreeShippingBar(0);

    return;
  }


  /*
   * Render products
   */
  container.innerHTML = cart.items.map((item, index) => {

    /*
     * Shopify cart line indexes are 1-based.
     */
    const line = index + 1;

    /*
     * Product image
     */
    const imageHtml = item.image
      ? `
        <a
          href="${escapeHtml(item.url || '#')}"
          class="block w-20 h-24 shrink-0 overflow-hidden bg-plaster-200"
        >
          <img
            src="${escapeHtml(item.image)}"
            alt="${escapeHtml(item.product_title || item.title)}"
            class="w-full h-full object-cover"
            loading="lazy"
          >
        </a>
      `
      : `
        <div class="w-20 h-24 shrink-0 bg-plaster-200"></div>
      `;


    /*
     * Variant
     */
    const variantHtml =
      item.variant_title &&
      item.variant_title !== 'Default Title'
        ? `
          <p class="mt-1 text-[10px] uppercase tracking-widest text-stone-500 font-light">
            ${escapeHtml(item.variant_title)}
          </p>
        `
        : '';


    /*
     * Quantity buttons
     */
    const decreaseQuantity = Math.max(0, item.quantity - 1);
    const increaseQuantity = item.quantity + 1;


    return `
      <div
        class="py-4 first:pt-0"
        data-cart-item
        data-cart-line="${line}"
        data-cart-key="${escapeHtml(item.key)}"
      >

        <div class="flex gap-4">

          ${imageHtml}


          <!-- Product information -->
          <div class="flex-1 min-w-0 flex flex-col justify-between">

            <div>

              <a
                href="${escapeHtml(item.url || '#')}"
                class="block font-serif text-sm text-stone-900 leading-snug hover:text-brass-aged transition-colors"
              >
                ${escapeHtml(item.product_title || item.title)}
              </a>

              ${variantHtml}

              <p class="mt-1 text-xs text-stone-600">
                ${formatMoney(item.final_line_price)}
              </p>

            </div>


            <!-- Quantity + Remove -->
            <div class="flex items-center justify-between mt-4">

              <!-- Quantity selector -->
              <div
                class="flex items-center border border-plaster-300"
                data-quantity-control
              >

                <!-- Minus -->
                <button
                  type="button"
                  onclick="updateCartQuantity(${line}, ${decreaseQuantity}, this)"
                  class="w-8 h-8 flex items-center justify-center text-stone-500 hover:text-stone-900 hover:bg-plaster-200 transition-colors disabled:opacity-40 disabled:pointer-events-none"
                  aria-label="Decrease quantity"
                  ${item.quantity <= 1 ? '' : ''}
                >
                  <span class="text-sm leading-none">−</span>
                </button>


                <!-- Quantity -->
                <span
                  class="w-9 text-center text-xs text-stone-900"
                  aria-live="polite"
                >
                  ${item.quantity}
                </span>


                <!-- Plus -->
                <button
                  type="button"
                  onclick="updateCartQuantity(${line}, ${increaseQuantity}, this)"
                  class="w-8 h-8 flex items-center justify-center text-stone-500 hover:text-stone-900 hover:bg-plaster-200 transition-colors disabled:opacity-40 disabled:pointer-events-none"
                  aria-label="Increase quantity"
                >
                  <span class="text-sm leading-none">+</span>
                </button>

              </div>


              <!-- Remove -->
              <button
                type="button"
                onclick="removeFromCart('${escapeHtml(item.key)}', this)"
                class="text-[9px] uppercase tracking-widest text-stone-400 hover:text-stone-900 transition-colors disabled:opacity-40"
              >
                Remove
              </button>

            </div>

          </div>

        </div>

      </div>
    `;
  }).join('');


  /*
   * Update subtotal
   */
  if (subtotalEl) {
    subtotalEl.innerText = formatMoney(cart.total_price);
  }


  /*
   * Update free shipping
   */
  renderFreeShippingBar(cart.total_price);


  /*
   * Re-initialize Lucide icons
   */
  if (window.lucide) {
    lucide.createIcons();
  }
}


/* ---------------- Cart Quantity Update ---------------- */

async function updateCartQuantity(line, quantity, button) {
  /*
   * Prevent negative quantities
   */
  quantity = Math.max(0, Number(quantity) || 0);


  /*
   * Disable all controls while updating.
   * This prevents double-clicking and sending multiple
   * simultaneous Shopify cart requests.
   */
  const container = document.getElementById('cartItemsContainer');

  if (container) {
    container
      .querySelectorAll('button')
      .forEach(btn => {
        btn.disabled = true;
      });
  }


  /*
   * Add a small visual loading state to the clicked button.
   */
  if (button) {
    button.classList.add('opacity-50');
  }


  try {
    const changeUrl =
      (window.NUHAS?.routes?.cartChange || '/cart/change') + '.js';


    const res = await fetch(changeUrl, {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    });


    if (!res.ok) {
      let errorData = {};

      try {
        errorData = await res.json();
      } catch (_) {}

      throw new Error(
        errorData.description || 'Could not update cart'
      );
    }


    /*
     * Shopify returns the updated cart.
     */
    const cart = await res.json();

    renderCartDrawer(cart);


  } catch (e) {
    console.error('Could not update cart quantity:', e);

    showToast(
      e.message || 'Could not update your shopping bag'
    );

    /*
     * Reload cart so the UI is definitely synchronized
     * with Shopify if the request failed.
     */
    await refreshCartUI();

  } finally {

    if (button) {
      button.classList.remove('opacity-50');
    }
  }
}


/* ---------------- Remove Cart Item ---------------- */

async function removeFromCart(key, button) {

  /*
   * Disable controls during request.
   */
  const container = document.getElementById('cartItemsContainer');

  if (container) {
    container
      .querySelectorAll('button')
      .forEach(btn => {
        btn.disabled = true;
      });
  }


  if (button) {
    button.classList.add('opacity-50');
  }


  try {
    const changeUrl =
      (window.NUHAS?.routes?.cartChange || '/cart/change') + '.js';


    const res = await fetch(changeUrl, {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });


    if (!res.ok) {
      let errorData = {};

      try {
        errorData = await res.json();
      } catch (_) {}

      throw new Error(
        errorData.description || 'Could not remove item'
      );
    }


    const cart = await res.json();

    renderCartDrawer(cart);


  } catch (e) {
    console.error('Could not remove item:', e);

    showToast(
      e.message || 'Could not remove item from your bag'
    );

    await refreshCartUI();

  } finally {

    if (button) {
      button.classList.remove('opacity-50');
    }
  }
}


/* ---------------- Free Shipping Bar ---------------- */

function renderFreeShippingBar(totalCents) {
  const bar = document.getElementById('freeShippingBar');

  if (
    !bar ||
    !window.NUHAS ||
    !window.NUHAS.freeShipping ||
    !window.NUHAS.freeShipping.enabled
  ) {
    return;
  }


  const threshold = window.NUHAS.freeShipping.threshold;


  if (!threshold || threshold <= 0) {
    bar.innerHTML = '';
    return;
  }


  /*
   * Free shipping unlocked
   */
  if (totalCents >= threshold) {

    bar.innerHTML = `
      <p class="text-[10px] uppercase tracking-widest text-brass-aged font-light">
        You've unlocked free shipping
      </p>

      <div class="w-full h-1 bg-plaster-300 rounded-full overflow-hidden">
        <div
          class="h-full bg-brass-aged transition-all duration-500"
          style="width:100%"
        ></div>
      </div>
    `;

    return;
  }


  /*
   * Still need more
   */
  const remaining = formatMoney(
    threshold - totalCents
  );


  const pct = Math.min(
    100,
    Math.round((totalCents / threshold) * 100)
  );


  bar.innerHTML = `
    <p class="text-[10px] uppercase tracking-widest text-stone-500 font-light">
      Add ${remaining} more for free shipping
    </p>

    <div class="w-full h-1 bg-plaster-300 rounded-full overflow-hidden">
      <div
        class="h-full bg-brass-aged transition-all duration-500"
        style="width:${pct}%"
      ></div>
    </div>
  `;
}


/* ---------------- Cart Note ---------------- */

function toggleCartNote() {
  const field = document.getElementById('cartNoteField');

  if (field) {
    field.classList.toggle('hidden');
  }
}


async function saveCartNote(note) {
  try {
    await fetch(
      (window.NUHAS?.routes?.cartUpdate || '/cart/update') + '.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          note
        })
      }
    );

  } catch (e) {
    console.error('Could not save order note:', e);
  }
}


/* ---------------- PDP Add To Cart ---------------- */

function initPDPAddToCart() {
  const form = document.getElementById('PDPForm');

  if (!form) return;


  form.addEventListener('submit', async (e) => {

    e.preventDefault();


    const formData = new FormData(form);


    try {

      const res = await fetch(
        (window.NUHAS?.routes?.cartAdd || '/cart/add') + '.js',
        {
          method: 'POST',

          headers: {
            'Accept': 'application/json'
          },

          body: formData
        }
      );


      if (!res.ok) {

        let err = {};

        try {
          err = await res.json();
        } catch (_) {}

        showToast(
          err.description || 'Could not add to bag'
        );

        return;
      }


      await res.json();


      /*
       * Refresh drawer contents after adding product.
       */
      await refreshCartUI();


      /*
       * Open drawer.
       */
      openCartDrawer();


      showToast('Added to your shopping bag');


    } catch (err) {

      console.error(err);

      showToast(
        'Something went wrong — please try again'
      );
    }
  });
}


/* ---------------- PDP Variant Selector ---------------- */

async function initPDPVariantSelector() {
  const form = document.getElementById('PDPForm');

  if (!form || !form.dataset.productUrl) return;


  const selects = [
    ...form.querySelectorAll('select[data-option-index]')
  ];


  const variantInput =
    form.querySelector('input[name="id"]');


  const priceEl =
    document.getElementById('pdpPrice');


  const submitBtn =
    form.querySelector('button[type="submit"]');


  if (!selects.length || !variantInput) return;


  try {

    const res = await fetch(
      form.dataset.productUrl
    );


    if (!res.ok) {
      throw new Error(
        `Product request failed: ${res.status}`
      );
    }


    const product = await res.json();


    const updateVariant = () => {

      const values = selects.map(
        select => select.value
      );


      const variant = product.variants.find(item =>
        item.options.every(
          (option, index) =>
            option === values[index]
        )
      );


      /*
       * No matching variant.
       */
      if (!variant) {

        variantInput.value = '';


        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Unavailable';
        }


        return;
      }


      /*
       * Set variant ID.
       */
      variantInput.value = variant.id;


      /*
       * Update price.
       */
      if (priceEl) {

        priceEl.textContent =
          product.price_varies
            ? `From ${formatMoney(variant.price)}`
            : formatMoney(variant.price);
      }


      /*
       * Update availability.
       */
      if (submitBtn) {

        submitBtn.disabled =
          !variant.available;

        submitBtn.textContent =
          variant.available
            ? 'Add to Bag'
            : 'Sold Out';
      }


      /*
       * Update URL.
       */
      const url =
        new URL(window.location.href);


      url.searchParams.set(
        'variant',
        variant.id
      );


      window.history.replaceState(
        {},
        '',
        url
      );
    };


    /*
     * Listen for option changes.
     */
    selects.forEach(select => {
      select.addEventListener(
        'change',
        updateVariant
      );
    });


    /*
     * Read selected variant from URL.
     */
    const selectedVariantId =
      new URLSearchParams(
        window.location.search
      ).get('variant');


    const selectedVariant =
      selectedVariantId
        ? product.variants.find(
            variant =>
              String(variant.id) ===
              selectedVariantId
          )
        : product.variants.find(
            variant =>
              variant.id ===
              Number(variantInput.value)
          );


    /*
     * Apply selected variant options.
     */
    if (selectedVariant) {

      selects.forEach(
        (select, index) => {

          if (
            selectedVariant.options[index] != null
          ) {
            select.value =
              selectedVariant.options[index];
          }

        }
      );
    }


    /*
     * Initial update.
     */
    updateVariant();


  } catch (error) {

    console.error(
      'Could not initialize product variants:',
      error
    );
  }
}


/* ---------------- Trade / Custom Modals ---------------- */

function openTradeModal() {
  const m = document.getElementById('tradeModal');

  if (!m) return;

  m.classList.remove(
    'opacity-0',
    'pointer-events-none'
  );

  m.classList.add(
    'opacity-100',
    'pointer-events-auto'
  );
}


function closeTradeModal() {
  const m = document.getElementById('tradeModal');

  if (!m) return;

  m.classList.add(
    'opacity-0',
    'pointer-events-none'
  );

  m.classList.remove(
    'opacity-100',
    'pointer-events-auto'
  );
}


function openCustomModal(productName) {
  const m = document.getElementById('customModal');

  if (!m) return;


  const productField =
    document.getElementById(
      'customFormProduct'
    );


  if (productField && productName) {
    productField.value = productName;
  }


  m.classList.remove(
    'opacity-0',
    'pointer-events-none'
  );

  m.classList.add(
    'opacity-100',
    'pointer-events-auto'
  );
}


function closeCustomModal() {
  const m =
    document.getElementById('customModal');

  if (!m) return;


  m.classList.add(
    'opacity-0',
    'pointer-events-none'
  );

  m.classList.remove(
    'opacity-100',
    'pointer-events-auto'
  );
}


/*
 * Shopify's native contact form does a full-page redirect
 * back on submit via each form's return_to field:
 * ?form_submitted=trade|custom
 *
 * Reopen the matching modal so the person sees the result
 * of their submission — success message or validation errors,
 * both rendered server-side.
 */

function initModalAutoOpen() {
  const submitted =
    new URLSearchParams(
      window.location.search
    ).get('form_submitted');


  if (submitted === 'trade') {
    openTradeModal();
  }


  if (submitted === 'custom') {
    openCustomModal();
  }
}


/* ---------------- Collection Filter Tabs ---------------- */

function filterProductsByTag(tag) {

  document
    .querySelectorAll('[data-filter-tab]')
    .forEach(btn => {

      if (
        btn.dataset.filterTab === tag
      ) {

        btn.className =
          'px-3 py-1.5 uppercase tracking-widest text-[9px] bg-stone-900 text-plaster-50 transition-colors';

      } else {

        btn.className =
          'px-3 py-1.5 uppercase tracking-widest text-[9px] text-stone-700 hover:text-stone-900 transition-colors';

      }

    });


  document
    .querySelectorAll('[data-product-tags]')
    .forEach(card => {

      const tags =
        card.dataset.productTags || '';


      const show =
        tag === 'all' ||
        tags.split(',').includes(tag);


      card.style.display =
        show ? '' : 'none';
    });
}


/* ---------------- Product Recommendations ---------------- */

async function loadProductRecommendations() {

  const el =
    document.getElementById(
      'product-recommendations'
    );


  if (!el || !el.dataset.url) return;


  try {

    const res =
      await fetch(el.dataset.url);


    const html =
      await res.text();


    const doc =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );


    const fresh =
      doc.getElementById(
        'product-recommendations'
      );


    if (fresh) {

      el.innerHTML =
        fresh.innerHTML;


      if (window.lucide) {
        lucide.createIcons();
      }
    }


  } catch (e) {

    console.error(
      'Could not load recommendations:',
      e
    );
  }
}


/* ---------------- Patina Lifespan Timeline ---------------- */

const patinaStages = [

  {
    year: 'Year 0',
    title: 'Fresh Hand-Buffed Luster',
    subtitle: 'Warm golden & copper glow',
    filter:
      'brightness(1.02) contrast(1) sepia(0.15)',
    desc:
      'Upon installation, unlacquered solid brass and copper hardware displays a smooth, warm golden and copper luster that reflects light softly with authentic depth.'
  },

  {
    year: 'Year 0.5',
    title: 'Initial Softening',
    subtitle: 'Touch-point contrast',
    filter:
      'brightness(0.96) contrast(1.02) sepia(0.3)',
    desc:
      'In areas touched daily—such as handles or pulls—natural skin contact slows surface oxidation while surrounding brass and copper deepens into honey and rose tones.'
  },

  {
    year: 'Year 2',
    title: 'Honey & Rose Patina',
    subtitle: 'Organic metal warmth',
    filter:
      'brightness(0.9) contrast(1.06) sepia(0.45) hue-rotate(-5deg)',
    desc:
      'The metals mature into rich amber-honey and deep copper tones. Ambient atmospheric humidity creates subtle natural variations across each sand-cast surface.'
  },

  {
    year: 'Year 5',
    title: 'Deep Architectural Tone',
    subtitle: 'Highlighted edges & soft depth',
    filter:
      'brightness(0.83) contrast(1.12) sepia(0.6) hue-rotate(-10deg)',
    desc:
      'A noble character emerges. Edges retain polished highlights from daily interaction, while flat surfaces develop quiet earth and patinated copper tones.'
  },

  {
    year: 'Year 10',
    title: 'Heritage Depth',
    subtitle: 'Timeless living metal',
    filter:
      'brightness(0.76) contrast(1.18) sepia(0.7) hue-rotate(-15deg)',
    desc:
      'After a decade, the brass and copper hardware belongs completely to the home—a permanent testament to genuine raw metal aging.'
  }

];


function updatePatinaStage(val) {

  const index =
    Math.min(
      Math.floor(val / 2.5),
      4
    );


  const data =
    patinaStages[index];


  const el =
    id => document.getElementById(id);


  if (el('patinaSliderVal')) {
    el('patinaSliderVal').innerText =
      val + ' Years';
  }


  if (el('patinaStageTitle')) {
    el('patinaStageTitle').innerText =
      data.title;
  }


  if (el('patinaStageSubtitle')) {
    el('patinaStageSubtitle').innerText =
      data.subtitle;
  }


  if (el('patinaYearTag')) {
    el('patinaYearTag').innerText =
      data.year;
  }


  if (el('patinaImg')) {
    el('patinaImg').style.filter =
      data.filter;
  }


  if (el('patinaDescription')) {
    el('patinaDescription').innerHTML =
      `<p>${data.desc}</p>`;
  }
}


function updatePDPPatina(val) {

  const index =
    Math.min(
      Math.floor(val / 2.5),
      4
    );


  const data =
    patinaStages[index];


  const el =
    id => document.getElementById(id);


  if (el('pdpPatinaLabel')) {
    el('pdpPatinaLabel').innerText =
      `${data.year}: ${data.title}`;
  }


  if (el('pdpPatinaImg')) {
    el('pdpPatinaImg').style.filter =
      data.filter;
  }


  if (el('pdpPatinaText')) {
    el('pdpPatinaText').innerText =
      data.desc;
  }
}


/* ---------------- Acoustic Soundscape (Tone.js) ---------------- */

let isAudioPlaying = false;
let synth = null;


function toggleAmbientSound() {

  const icon =
    document.getElementById(
      'soundIcon'
    );


  const label =
    document.getElementById(
      'soundLabel'
    );


  if (
    !icon ||
    !label ||
    typeof Tone === 'undefined'
  ) {
    return;
  }


  if (!isAudioPlaying) {

    try {

      Tone.start();


      synth =
        new Tone.Synth({

          oscillator: {
            type: 'sine'
          },

          envelope: {
            attack: 4,
            decay: 4,
            sustain: 0.8,
            release: 4
          }

        }).toDestination();


      synth.volume.value = -30;


      synth.triggerAttack('A2');


      isAudioPlaying = true;


      icon.setAttribute(
        'data-lucide',
        'volume-2'
      );


      label.innerText =
        'Active';


    } catch (e) {

      console.log(
        'Audio init prevented:',
        e
      );
    }


  } else {

    if (synth) {
      synth.triggerRelease();
    }


    isAudioPlaying = false;


    icon.setAttribute(
      'data-lucide',
      'volume-x'
    );


    label.innerText =
      'Soundscape';
  }


  if (window.lucide) {
    lucide.createIcons();
  }
}
